module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "part-001"
    }
  }, [_c('div', {
    staticClass: "part_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "part_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_1"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH")])])])]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_1"
    }
  }), _c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-001"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_1"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  })]), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_1"
    }
  }, [_c('span', [_vm._v("JEREMIAH’S CALL FROM THE WOMB"), _c('br')])]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Jeremiah+1%3A1-5&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("JEREMIAH 1:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW:")])]), _vm._v("Jeremiah is considered to be one of the major prophets (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("). The call to Jeremiah first came during the days of the godly king Josiah, whose godliness lay in stark contrast to those kings who came before him or those who followed him (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET")]), _vm._v("). God’s choice of Jeremiah was based on his foreknowledge concerning Jeremiah (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("), and thus God consecrated Jeremiah to be a prophet even before he was born (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET")]), _vm._v("). Thus, God demonstrated his care and concern especially for the weak and helpless (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("), for the unborn who are formed by the Word of God and given life by him as full human beings even in the womb (M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETHODIUS, ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTULLIAN, ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENAEUS, ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERUSALEM")]), _vm._v("). The child in the womb is capable of faith, as is seen by God’s Word to Jeremiah as well as the actions of John the Baptist in the womb (M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AXIMUS, ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). One is made a child of faith not in the mother’s womb, however, but in the power of baptism (L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EO")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("These opening words in Jeremiah were also used by the ancient Christian writers to demonstrate a twofold nature in Christ, the divine and fleshly: the former from the Father, the latter from a virgin (L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACTANTIUS, ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v("). The Son is not created or formed but is the Father’s image and Word begotten from eternity (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THANASIUS")]), _vm._v(", A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-028"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:2 "), _c('i', [_vm._v("In the Days of Josiah")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE OF THE ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AJOR ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHETS. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("Jeremiah, like Isaiah, is one of the "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_2"
    }
  }, [_vm._v("major prophets, not of the minor, like the others from whose writings I have just given extracts. He prophesied when Josiah reigned in Jerusalem and Ancus Martius at Rome, when the captivity of the Jews was already at hand; and he continued to prophesy down to the fifth month of the captivity, as we find from his writings. Zephaniah, one of the minor prophets, is put along with him, because he himself says that he prophesied in the days of Josiah; but he does not say till when. Jeremiah thus prophesied not only in the times of Ancus Martius but also in those of Tarquinius Priscus, whom the Romans had for their fifth king. For he had already begun to reign when that captivity took place. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITY OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD 18.33.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN1",
      "id": "ap_NFIN1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ING ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSIAH’S ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMILY. ")])]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("King Josiah’s father was Amon, an impious man. His grandfather was Manasseh, who had instructed Josiah’s father in his impiety. Josiah, on the contrary, went the exact opposite of them, siding with the party of the godly. His children, however, showed no interest in their father’s virtue and imitated their forefathers’ godlessness. Knowing this in advance, therefore, the God of all elected the prophet in the thirteenth year of Josiah’s reign and commanded him to foretell the calamities that would befall both city and people. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH 1.")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RGUMENT.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN2",
      "id": "ap_NFIN2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-029"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:5 "), _c('i', [_vm._v("Called and Consecrated in the Womb")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLING. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE: ")]), _vm._v("Moreover, this calling, which works through the opportune circumstances of history, whether this calling is in individuals or in peoples or in humankind itself, comes from a decree both lofty and profound. To this relates the following passage: “In the womb have I sanctified you.” O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHTY-")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE ")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARIED ")]), _vm._v("Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UESTIONS 68.6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN3",
      "id": "ap_NFIN3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSECRATED FROM THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMB.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR")]), _vm._v(": God’s choice of Jeremiah was not without basis: knowledge preceded it. Notice it says that God had knowledge and then he consecrated, for he knows everything before it happens. Now, he employed the word consecrated, meaning “he appointed.” Then God also mentions the task for which he selected him: “I appointed you as prophet to the nations.” Thus, he prophesies not only concerning the fortunes of the Jews but also the other nations. “I replied, O Lord and Master that you are, see, I do not know how to speak, because I am a child.” The prophet recognized the one addressing him. This is why he called him by a title having to do with lordship. When the mighty Moses was once speaking, remember, and wanted to learn the divine name, the Lord said, “I am the one who is.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN4",
      "id": "ap_NFIN4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" He imitates Moses’ timidity by saying youth is not up to prophesying. The Lord, however, urges him not to put forward the excuse of youthfulness but to do as he is told. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH 1.1.4-6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN5",
      "id": "ap_NFIN5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARES FOR THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAK AND ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAIL. ")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("We forget that the words “Let us make man according to our image and according to our likeness”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN6",
      "id": "ap_NFIN6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v("apply to each person. When we fail to remember the one who formed a person in the womb, and formed all people’s hearts individually and understands all their works,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN7",
      "id": "ap_NFIN7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" we do not perceive that God is a helper of those who are lowly and inferior, a protector of the weak, a provider of shelter of those who have been given up in despair and Savior of those who have been given up as hopeless."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN8",
      "id": "ap_NFIN8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN 13.167-68.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN9",
      "id": "ap_NFIN9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_3"
    }
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFT OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILDREN. ")])]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETHODIUS: ")]), _vm._v("So, if God still forms human beings, shall we not be guilty of audacity if we think of the generation of children as something offensive when even the Almighty is not ashamed to make use of them in working with his undefiled hands. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANQUET OF THE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN ")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRGINS 2.2.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN10",
      "id": "ap_NFIN10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATES ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUL AND ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODY IN THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMB.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTULLIAN: ")]), _vm._v("Read the word of God that was spoken to Jeremiah, “Before I formed you in the womb, I knew you.” God not only forms us in the womb; he also breathes on us as he did at the first creation, when “the Lord God formed man and breathed into him the breath of life.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN11",
      "id": "ap_NFIN11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" And God could not have known a person in the womb, except in his entire nature: “And before you came forth out of the womb, I sanctified you.” Well, was it then a dead body at that early stage? Certainly not. For “God is not the God of the dead but of the living."), _c('span', {
    staticClass: "small"
  }, [_vm._v("” ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUL 26.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN12",
      "id": "ap_NFIN12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE AT THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBRYONIC ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TAGE. ")])]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERTULLIAN: ")]), _vm._v("The embryo therefore becomes a human being in the womb from the moment that its form is completed. The law of Moses,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN13",
      "id": "ap_NFIN13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" indeed, punishes with due penalties the one who shall cause an abortion, inasmuch as there exists already the rudiment of a human being that has imputed to it even now the condition of life and death, since it is already liable to the issues of both, although, by living still in the mother, it for the most part shares its own state with the mother. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUL 37.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN14",
      "id": "ap_NFIN14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD OF ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORMS ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S IN THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMB. ")])]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENAEUS: ")]), _vm._v("The Word of God is the one who forms us in the womb, as he says to Jeremiah, “Before I formed you in the womb, I knew you. Before you came forth from the belly, I sanctified you and appointed you to be a prophet among the nations.” And Paul, too, says this in the same way, “But when it pleased God, who separated me from my mother’s womb, that I might declare him among the nations.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN15",
      "id": "ap_NFIN15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GAINST ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERESIES 5.15.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN16",
      "id": "ap_NFIN16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVES AND ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORMS THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESH OF ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMANITY. ")])]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERUSALEM: ")]), _vm._v("He is not ashamed to assume flesh, who is the creator of those very parts. Who tells us this? The Lord said to Jeremiah: “Before I formed you in the belly, I knew you. Before you came forth out of the womb, I made you holy.” If, then, in making humanity he was not ashamed of the contact, was he ashamed in making for his own sake the holy flesh, the veil of his Godhead? It is God who even now creates children in the womb, as it is written in Job, “Didn’t you pour me out as milk and curdled me like cheese? You have clothed me with skin and flesh and have knit me together with bones and sinews.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN17",
      "id": "ap_NFIN17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" There is nothing polluted in the human frame unless a person defiles it with fornication and adultery. God, who made Adam, also made Eve. Both male and female were formed by God’s hands. None of the parts of the body as formed from the beginning are polluted. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATECHETICAL ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECTURES 12.26.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN18",
      "id": "ap_NFIN18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH AND ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN IN THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMB. ")])]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AXIMUS OF ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URIN: ")]), _vm._v("This, too, seems unworthy to pass over in silence in praise of John. Although he was not yet born, yet already he prophesies and, while still in the enclosure of his mother’s womb, confesses the coming of Christ with movements of joy since he could not do so with his voice. . . . In this regard I think that the prophetic phrase is appropriate that says, “Before I formed you in the womb I knew you, and before you were born I consecrated you.” We ought not to marvel that after he was put in prison by Herod, from his confinement he continued to announce Christ to his disciples, when even confined in the womb he preached the same Lord by his movements. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMON 5.4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN19",
      "id": "ap_NFIN19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSECRATED IN THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMB. ")])]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME: ")]), _vm._v("It was not that Jeremiah existed before he was conceived, as some heretics suppose, but that the Lord foreknew Jeremiah to be coming, the Lord to whom what does not yet exist is already present, in accordance with what the apostle said "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_4"
    }
  }, [_vm._v("of him: “who calls that which is not as though it were.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN20",
      "id": "ap_NFIN20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" But we also ought to understand Jeremiah’s consecration in the womb according to the apostle’s word: “When it pleased him, he set me apart from my mother’s womb and called me by his grace, to reveal his Son in me, that I might proclaim him to the nations.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN21",
      "id": "ap_NFIN21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" John the Baptist similarly was consecrated in the womb, where he received the Holy Spirit and leaped and spoke through his mother’s mouth."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN22",
      "id": "ap_NFIN22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Furthermore, when the Lord says, “I appointed you a prophet to the nations,” he wants it to be understood that we will eventually read in him the prophet who will prophesy not only to Jerusalem but also to a multitude in the entire company of nations. Some understand this as referring to the Savior, who was himself a prophet to the nations and called all peoples through the apostles. For it is certainly true of him that before he was formed in the virginal womb of his mother and before he came forth from her, he was consecrated in the womb and was known to the Father, he, indeed, who is always in the Father and the Father always in him."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN23",
      "id": "ap_NFIN23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IX ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS ON ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH 1.2.1-3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN24",
      "id": "ap_NFIN24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWER OF ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APTISM. ")])]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EO THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAT: ")]), _vm._v("Through the Holy Spirit we are reborn the children of promise, not in the mother’s womb but in the power of baptism. For this reason David, who certainly was a son of promise, says to God, “Your hands have made and fashioned me.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN25",
      "id": "ap_NFIN25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" And to Jeremiah the Lord says, “Before I formed you in the womb I knew you, and before you were born I consecrated you.” L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER 15.10.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN26",
      "id": "ap_NFIN26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WOFOLD ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRTH OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST. ")])]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACTANTIUS: ")]), _vm._v("In the first place we testify that he was born twice: first, in the spirit, later in the flesh. It is said in Jeremiah, “Before I formed you in the womb I knew you.” And again, “who was blessed before he was born,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN27",
      "id": "ap_NFIN27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" which happened to no other besides Christ. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVINE ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSTITUTES 4.8.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN28",
      "id": "ap_NFIN28-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCARNATION AND THE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATURES IN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE: ")]), _vm._v("“The bosom of the Father”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN29",
      "id": "ap_NFIN29-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" is to be understood in a spiritual sense, as a kind of innermost dwelling of the Father’s love and of his nature, in which the Son always dwells. Even so, the Father’s womb is the spiritual womb of an inner sanctuary, from which the Son has proceeded just as from a generative womb. . . . The Father speaks of that womb through the prophet Jeremiah: “Before I formed you in the womb I knew you, and before you were born I consecrated you.” Therefore, the prophet showed that there was a twofold nature in Christ, the divine and the fleshly, the former from the Father, the latter from a virgin, but in such a way that Christ was not deprived of his divinity when he was born from a virgin and was in the body. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATRIARCHS 11.51.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN30",
      "id": "ap_NFIN30-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GAINST THE ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIANS. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THANASIUS: ")]), _vm._v("Concerning Jeremiah, God says, “Before I formed you in the womb, I knew you.” . . . If such "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "R_5"
    }
  }, [_vm._v("terms are used in Scripture of things created, but the term ever is used of the Word, then it follows, O enemies of God, that the Son did not come out of nothing, nor is he to be numbered at all among created things, but he is the Father’s image and eternal word, never having not existed, but never existing as the eternal radiance. D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISCOURSES ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GAINST THE ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIANS 1.4.13.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN31",
      "id": "ap_NFIN31-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST’S ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEXISTENCE. ")])]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE: ")]), _vm._v("To show them, however, the weakness and transparency of their objection, though it has no real relation to any truth, divine or human, I will prove to them that people have existed before they were born. Let them show that Jacob had not been appointed and ordained, even before he was born. While yet hidden in the secret chamber of his mother’s womb, he supplanted his brother. Let them show that Jeremiah had not likewise been so, before his birth, “Before I formed you in your mother’s womb, I knew you; and before you came forth from the belly, I sanctified you, and appointed you for a prophet amongst the nations.” . . . What do you [Arians] mean by your principle that “before he was begotten he did not exist”? Was the Father engaged for some time in conception, so that certain epochs passed away before the Son was begotten? O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH 4.9.113, 116.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen14#NFIN32",
      "id": "ap_NFIN32-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 81
// module chunks = 0